import { Link, LinkProps } from 'react-router-dom';
import { cn } from '../../utils/cn';

export type Variant = 'filled' | 'outlined' | 'text';
interface ActionLinkProps extends LinkProps {
    className?: string;
    variant?: Variant;
    disabled?: boolean;
    external?: boolean;
    isBlank?: boolean;
    children?: React.ReactNode | React.ReactNode[];
}

const baseClassName =
    '!rounded-lg py-3 px-3 sm:px-10 min-h-12 w-full md:max-w-80 w-full text-base font-semibold !leading-relaxed flex justify-center items-center transition';

const variantClasses: Record<Variant, string> = {
    filled: 'bg-primary text-white border border-primary',
    outlined: 'text-primary border border-primary bg-transparent',
    text: 'text-primary w-fit p-0 h-auto',
};

const disabledClasses: Record<Variant, string> = {
    filled: 'pointer-events-none bg-custom-bg-disabled border-custom-bg-disabled ',
    outlined:
        'pointer-events-none border-primary-textDisabled text-primary-textDisabled pointer-events-none cursor-not-allowed',
    text: 'pointer-events-none text-primary-textDisabled',
};

const ActionLink: React.FC<ActionLinkProps> = ({
    variant = 'filled',
    className = '',
    disabled,
    external,
    isBlank = true,
    children,
    to,
    ...props
}) => {
    const classes = cn(
        baseClassName,
        variantClasses[variant],
        disabled && disabledClasses[variant],
        className
    );

    if (disabled) {
        return <span className={cn(classes)}>{children}</span>;
    }

    if (external) {
        const externalProps = isBlank
            ? {
                  target: '_blank',
                  rel: 'noopener noreferrer',
              }
            : {};
        return (
            <a href={to.toString()} {...externalProps} className={classes}>
                {children}
            </a>
        );
    }

    return (
        <Link to={to} className={classes} {...props}>
            {children}
        </Link>
    );
};

export default ActionLink;
